// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { LogManager } from "@lib/logging/LogManager";
import { Socket } from "@lib/messaging/Socket";
import { TypeUtility } from "@lib/utilities/TypeUtility";

const log = LogManager.createLog("messaging.sockets.EventSocket");

/**
 * Provides methods for sending and receiving messages via DOM events.
 * Used by the website to send messages to the content scripts.
 */
export class EventSocket extends Socket
{
  readonly eventTarget: EventTarget;
  readonly receiveEventName: string;
  readonly sendEventName: string;

  constructor(eventTarget: EventTarget, receiveEventName: string, sendEventName: string)
  {
    super();
    if (receiveEventName === sendEventName)
      throw new Error("The name of the receive event can not be the same as the send event.");

    this.eventTarget = eventTarget;
    this.receiveEventName = receiveEventName;
    this.sendEventName = sendEventName;

    this.eventTarget.addEventListener(receiveEventName, (event: Event) => this.handleMessage(event));
  }

  sendMessage(message: object): void
  {
    const event = new CustomEvent(this.sendEventName, { detail: JSON.stringify(message) });
    this.eventTarget.dispatchEvent(event);
  }

  private handleMessage(event: Event): void
  {
    const customEvent = event as CustomEvent;
    if (customEvent.detail)
    {
      const rawMessage = JSON.parse(customEvent.detail);
      if (!TypeUtility.isObject(rawMessage))
        log.warn("Invalid message: %o", rawMessage);

      this._onMessage.dispatch(rawMessage);
    }
  }
}